import { ChangeDetectionStrategy, Component, Inject, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { DatabaseRestorePreview, DatabaseRestoreOptions } from '../../../models/simulator.models';

export interface RestoreDatabaseDialogData {
  preview: DatabaseRestorePreview;
  allowRestoreScoring: boolean;
}

@Component({
  selector: 'app-restore-database-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './restore-database-dialog.component.html',
  styleUrls: ['./restore-database-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RestoreDatabaseDialogComponent {
  readonly preview: DatabaseRestorePreview;
  readonly allowRestoreScoring: boolean;
  readonly restoreScoring = signal(true);
  readonly clearSimulator = signal(true);

  readonly canConfirm = computed(() => {
    if (this.allowRestoreScoring && this.restoreScoring()) {
      return this.clearSimulator();
    }

    return this.clearSimulator();
  });

  onRestoreScoringToggle(isChecked: boolean): void {
    this.restoreScoring.set(isChecked);
    if (isChecked) {
      this.clearSimulator.set(true);
    }
  }

  constructor(
    private readonly dialogRef: DialogRef<DatabaseRestoreOptions | null>,
    @Inject(DIALOG_DATA) private readonly data: RestoreDatabaseDialogData
  ) {
    this.preview = data.preview;
    this.allowRestoreScoring = data.allowRestoreScoring;
    this.restoreScoring.set(data.allowRestoreScoring);
  }

  onConfirm(): void {
    this.dialogRef.close({
      restoreScoring: this.restoreScoring(),
      clearSimulator: this.clearSimulator()
    });
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
